import React from 'react';

import { AccordionBlockData } from 'api/cms';
import { Body, BodySmall, H2, H3 } from 'components/Text';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const AccordionBlock = ({
  data: { sections, headline, subtitle },
}: {
  data: AccordionBlockData;
}) => (
  <>
    {headline && <H2>{headline}</H2>}
    {subtitle && (
      <Body
        dangerouslySetInnerHTML={{
          __html: subtitle,
        }}
      />
    )}
    {sections.map((section, index) => (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>
        <H3>{section.title}</H3>
        <BodySmall
          dangerouslySetInnerHTML={{
            __html: section.content,
          }}
        />
      </React.Fragment>
    ))}
  </>
);

// eslint-disable-next-line import/no-default-export
export default AccordionBlock;
